import React, { useState } from 'react';

import Uuid from '../../../../../support/Uuid';
import DetallesDelServicioMain from './DetallesDelServicioMain';
import DetallesDelServicioList from './DetallesDelServicioList';

const DetallesDelServicioManager = (props) => {
  const [editing, setEditing] = useState(null);

  const handleOnAdd = (data) => {
    const { Servicios = {} } = props.data;
    const { DetallesDelServicio = [] } = Servicios;

    const newData = DetallesDelServicio.concat([
      {
        id: Uuid.v4(),
        ...data,
      },
    ]);

    setEditing(null);

    handleOnListChange(newData);
  };

  const handleOnEdit = (item) => {
    setEditing(item);

    const { Servicios = {} } = props.data;
    const { DetallesDelServicio = [] } = Servicios;

    const newData = DetallesDelServicio.filter((value) => value.id !== item.id);

    handleOnListChange(newData);
  };

  const handleOnListChange = (data) => {
    props.onFormDataChange(
      {
        ...props.data,
        Servicios: {
          ...props.data.Servicios,
          DetallesDelServicio: data,
        },
      },
      { name: 'isValidServicios', isValid: true }
    );
  };

  const { data: original, Version } = props;

  const { Servicios = {} } = props.data;
  const { DetallesDelServicio = [] } = Servicios;

  return (
    <div className="pb-4">
      <div>
        <strong className="text-black text-upper">Detalles Del Servicio</strong>
      </div>

      <div className="pt-2">
        <DetallesDelServicioMain
          editing={editing}
          version={Version}
          original={original}
          onAdd={handleOnAdd}
        />
      </div>

      <div className="pt-2">
        <DetallesDelServicioList
          editing={editing}
          data={DetallesDelServicio}
          onEdit={handleOnEdit}
          onChange={handleOnListChange}
        />
      </div>
    </div>
  );
};

export default DetallesDelServicioManager;
